export const SkillsData = [
	{
		type: "Programming Languages",
		list: [
			{
				name: "HTML",
				icon: <i className="devicon-html5-plain colored" />
			},
			{
				name: "CSS",
				icon: <i className="devicon-css3-plain colored" />
			},
			{
				name: "JavaScript",
				icon: <i className="devicon-javascript-plain colored" />
			},
			{
				name: "TypeScript",
				icon: <i class="devicon-typescript-plain colored"></i>
			},
			{
				name: "Python",
				icon: <i className="devicon-python-plain colored" />
			},
			{
				name: "Java",
				icon: <i className="devicon-java-plain colored" />
			},
			{
				name: "C++",
				icon: <i className="devicon-cplusplus-plain colored" />
			},
			{
				name: "php",
				icon: <i className="devicon-php-plain colored" />
			}
		]
	},
	{
		type: "Frameworks/Libraries/Others",
		list: [
			{
				name: "Numpy",
				icon: <i className="devicon-numpy-original colored" />
			},
			{
				name: "Pandas",
				icon: <i className="devicon-pandas-original colored" />
			},
			{
				name: "React",
				icon: <i className="devicon-react-original colored" />
			},
			{
				name: "Bootstrap",
				icon: <i className="devicon-bootstrap-plain colored" />
			},
			{
				name: "Node.js",
				icon: <i className="devicon-nodejs-plain colored" />
			},
			{
				name: "MySQL",
				icon: <i className="devicon-mysql-plain colored" />
			},
			{
				name: 'Angular',
				icon: <i class="devicon-angularjs-plain colored"></i>
			},
			{
				name: '.NET Core',
				icon: <i class="devicon-dotnetcore-plain colored"></i>
			}
		]
	}
];
